export const GET_PATIENTS = 'waitingRoom/GET_PATIENTS'
export const GET_PATIENTS_BACKGROUND = 'waitingRoom/GET_PATIENTS_BACKGROUND'
export const GET_PATIENTS_SUCCESS = 'waitingRoom/GET_PATIENTS_SUCCESS'
export const GET_PATIENTS_ERROR = 'waitingRoom/GET_PATIENTS_ERROR'

export const GET_PROVIDER = 'waitingRoom/GET_PROVIDER'
export const GET_PROVIDER_SUCCESS = 'waitingRoom/GET_PROVIDER_SUCCESS'
export const GET_PROVIDER_ERROR = 'waitingRoom/GET_PROVIDER_ERROR'

export const START_VISIT_VIDEO_CALL = 'waitingRoom/START_VISIT_VIDEO_CALL'
export const START_VISIT_VIDEO_CALL_SUCCESS = 'waitingRoom/START_VISIT_VIDEO_CALL_SUCCESS'
export const START_VISIT_VIDEO_CALL_ERROR = 'waitingRoom/START_VISIT_VIDEO_CALL_ERROR'
export const SET_PHONE_ERROR = 'waitingRoom/SET_PHONE_ERROR'
export const CLEAR_PHONE_ERROR = 'waitingRoom/CLEAR_PHONE_ERROR'

export const COMPLETE_VISIT_CALL = 'waitingRoom/COMPLETE_VISIT_CALL'
export const COMPLETE_VISIT_CALL_SUCCESS = 'waitingRoom/COMPLETE_VISIT_CALL_SUCCESS'
export const COMPLETE_VISIT_CALL_ERROR = 'waitingRoom/COMPLETE_VISIT_CALL_ERROR'

export const GET_VISIT_INFO = 'waitingRoom/GET_VISIT_INFO'
export const GET_VISIT_INFO_SUCCESS = 'waitingRoom/GET_VISIT_INFO_SUCCESS'
export const GET_VISIT_INFO_ERROR = 'waitingRoom/GET_VISIT_INFO_ERROR'

export const GET_PHONE_CALL_TOKEN = 'waitingRoom/GET_PHONE_CALL_TOKEN'
export const GET_PHONE_CALL_TOKEN_SUCCESS = 'waitingRoom/GET_PHONE_CALL_TOKEN_SUCCESS'
export const GET_PHONE_CALL_TOKEN_ERROR = 'waitingRoom/GET_PHONE_CALL_TOKEN_ERROR'

export const GET_VISIT_PATIENT_CHART = 'waitingRoom/GET_VISIT_PATIENT_CHART'
export const GET_VISIT_PATIENT_CHART_SUCCESS = 'waitingRoom/GET_VISIT_PATIENT_CHART_SUCCESS'
export const GET_VISIT_PATIENT_CHART_ERROR = 'waitingRoom/GET_VISIT_PATIENT_CHART_ERROR'

export const ADD_PATIENT_ALLERGY = 'waitingRoom/ADD_PATIENT_ALLERGY'
export const ADD_PATIENT_ALLERGY_SUCCESS = 'waitingRoom/ADD_PATIENT_ALLERGY_SUCCESS'
export const ADD_PATIENT_ALLERGY_ERROR = 'waitingRoom/ADD_PATIENT_ALLERGY_ERROR'

export const DELETE_PATIENT_ALLERGY = 'waitingRoom/DELETE_PATIENT_ALLERGY'
export const DELETE_PATIENT_ALLERGY_SUCCESS = 'waitingRoom/DELETE_PATIENT_ALLERGY_SUCCESS'
export const DELETE_PATIENT_ALLERGY_ERROR = 'waitingRoom/DELETE_PATIENT_ALLERGY_ERROR'

export const SAVE_VISIT_NOTES = 'waitingRoom/SAVE_VISIT_NOTES'
export const SAVE_VISIT_NOTES_SUCCESS = 'waitingRoom/SAVE_VISIT_NOTES_SUCCESS'
export const SAVE_VISIT_NOTES_ERROR = 'waitingRoom/SAVE_VISIT_NOTES_ERROR'

export const SAVE_VISIT_PATIENT_INSTRUCTIONS = 'waitingRoom/SAVE_VISIT_PATIENT_INSTRUCTIONS'
export const SAVE_VISIT_PATIENT_INSTRUCTIONS_SUCCESS = 'waitingRoom/SAVE_VISIT_PATIENT_INSTRUCTIONS_SUCCESS'
export const SAVE_VISIT_PATIENT_INSTRUCTIONS_ERROR = 'waitingRoom/SAVE_VISIT_PATIENT_INSTRUCTIONS_ERROR'

export const GET_PATIENT_PRESCRIPTIONS = 'waitingRoom/GET_PATIENT_PRESCRIPTIONS_INSTRUCTIONS'
export const GET_PATIENT_PRESCRIPTIONS_SUCCESS = 'waitingRoom/GET_PATIENT_PRESCRIPTIONS_SUCCESS'
export const GET_PATIENT_PRESCRIPTIONS_ERROR = 'waitingRoom/GET_PATIENT_PRESCRIPTIONS_ERROR'

export const GET_PATIENT_TREAT_URL = 'waitingRoom/GET_PATIENT_TREAT_URL'
export const GET_PATIENT_TREAT_URL_SUCCESS = 'waitingRoom/GET_PATIENT_TREAT_URL_SUCCESS'
export const GET_PATIENT_TREAT_URL_ERROR = 'waitingRoom/GET_PATIENT_TREAT_URL_ERROR'

export const END_VISIT = 'waitingRoom/END_VISIT'
export const END_VISIT_SUCCESS = 'waitingRoom/END_VISIT_SUCCESS'
export const END_VISIT_ERROR = 'waitingRoom/END_VISIT_ERROR'

export const DELETE_VISIT_NOTES = 'waitingRoom/DELETE_VISIT_NOTES'
export const DELETE_VISIT_NOTES_SUCCESS = 'waitingRoom/DELETE_VISIT_NOTES_SUCCESS'
export const DELETE_VISIT_NOTES_ERROR = 'waitingRoom/DELETE_VISIT_NOTES_ERROR'

export const DELETE_VISIT_PATIENT_INSTRUCTIONS = 'waitingRoom/DELETE_VISIT_PATIENT_INSTRUCTIONS'
export const DELETE_VISIT_PATIENT_INSTRUCTIONS_SUCCESS = 'waitingRoom/DELETE_VISIT_PATIENT_INSTRUCTIONS_SUCCESS'
export const DELETE_VISIT_PATIENT_INSTRUCTIONS_ERROR = 'waitingRoom/DELETE_VISIT_PATIENT_INSTRUCTIONS_ERROR'

export const SEARCH_FOR_ICD_CODES = 'waitingRoom/SEARCH_FOR_ICD_CODES'
export const SEARCH_FOR_ICD_CODES_ERROR = 'waitingRoom/SEARCH_FOR_ICD_CODES_ERROR'
export const SEARCH_FOR_ICD_CODES_SUCCESS = 'waitingRoom/SEARCH_FOR_ICD_CODES_SUCCESS'

export const UPDATE_ICD_CODES = 'waitingRoom/UPDATE_ICD_CODES'
export const UPDATE_ICD_CODES_SUCCESS = 'waitingRoom/UPDATE_ICD_CODES_SUCCESS'
export const UPDATE_ICD_CODES_ERROR = 'waitingRoom/UPDATE_ICD_CODES_ERROR'
export const SET_UPDATING_ICD_CODES = 'waitingRoom/SET_UPDATING_ICD_CODES'

export const BACK_IN_QUEUE = 'waitingRoom/BACK_IN_QUEUE'
export const BACK_IN_QUEUE_ERROR = 'waitingRoom/BACK_IN_QUEUE_ERROR'

export const SET_LOADING = 'waitingRoom/SET_LOADING'
export const SET_ERROR = 'waitingRoom/SET_ERROR'
export const SET_VISIT_INFO = 'waitingRoom/SET_VISIT_INFO'
export const SET_IS_ROOM_SUCCESS_CREATED = 'waitingRoom/SET_IS_ROOM_SUCCESS_CREATED'
export const SET_FORCE_UPDATE_WAITING_ROOM = 'waitingRoom/SET_FORCE_UPDATE_WAITING_ROOM'
export const SET_VISIT_ROOM = 'waitingRoom/SET_VISIT_ROOM'
export const SET_PATIENT_TREAT_URL = 'waitingRoom/SET_PATIENT_TREAT_URL'
export const SET_IS_VISIT_NOTES_SAVED_SUCCESS = 'waitingRoom/SET_IS_VISIT_NOTES_SAVED_SUCCESS'
export const SET_ERROR_ALLERGY = 'waitingRoom/SET_ERROR_ALLERGY'
export const SET_IS_PATIENT_INSTRUCTIONS_SAVED_SUCCESS = 'waitingRoom/SET_IS_PATIENT_INSTRUCTIONS_SAVED_SUCCESS'
export const SET_NEW_PROVIDER_PROFILE_SETTINGS = 'waitingRoom/SET_NEW_PROVIDER_PROFILE_SETTINGS'

export const SUCCESS_VISIT = 'waitingRoom/SUCCESS_VISIT'
export const CHANGE_CURRENT_PATIENT_ACCOUNT_INFO = 'waitingRoom/CHANGE_CURRENT_PATIENT_ACCOUNT_INFO'
export const CHANGE_IS_VISIT_ENDED = 'waitingRoom/CHANGE_IS_VISIT_ENDED'

export const CLEAR_PHONE_TOKEN = 'waitingRoom/CLEAR_PHONE_TOKEN'
export const CLEAR_STALE_CALL_TOKENS = 'waitingRoom/CLEAR_STALE_CALL_TOKENS'

export const LEAVE_VISIT_ROOM = 'waitingRoom/LEAVE_VISIT_ROOM'

export const RESET_IS_ADDED_ALLERGY_STATUS = 'waitingRoom/RESET_IS_ADDED_ALLERGY_STATUS'
export const RESET_IS_DELETED_ALLERGY_STATUS = 'waitingRoom/RESET_IS_DELETED_ALLERGY_STATUS'
export const RESET_WAITING_ROOM_PAGE = 'waitingRoom/RESET_WAITING_ROOM_PAGE'

export const visitNotStarted = 'VisitNotStarted'

export const text = {
  SEARCH_VALUE: 'search value',
  ICD_CODE: 'icd code',
}

export const SET_VISIT_PATIENT_HAS_ALLERGIES = 'charts/SET_VISIT_PATIENT_HAS_ALLERGIES'
export const SET_VISIT_PATIENT_HAS_ALLERGIES_SUCCESS = 'charts/SET_VISIT_PATIENT_HAS_ALLERGIES_SUCCESS'
export const SET_VISIT_PATIENT_HAS_ALLERGIES_ERROR = 'charts/SET_VISIT_PATIENT_HAS_ALLERGIES_ERROR'

export const SET_VISIT_PATIENT_HAS_NO_ALLERGIES = 'charts/SET_VISIT_PATIENT_HAS_NO_ALLERGIES'
export const SET_VISIT_PATIENT_HAS_NO_ALLERGIES_SUCCESS = 'charts/SET_VISIT_PATIENT_HAS_NO_ALLERGIES_SUCCESS'
export const SET_VISIT_PATIENT_HAS_NO_ALLERGIES_ERROR = 'charts/SET_VISIT_PATIENT_HAS_NO_ALLERGIES_ERROR'
export const ADD_VISIT_ORDER = 'inProgressVisit/ADD_VISIT_ORDER'

export const SET_IS_VIDEO_DECLINED = 'waitingRoom/SET_IS_VIDEO_DECLINED'
export const SET_IS_REQUESTING_PERMISSIONS = 'waitingRoom/SET_IS_REQUESTING_PERMISSIONS'
export const SET_PERMISSIONS_GRANTED = 'waitingRoom/SET_PERMISSIONS_GRANTED'
export const SET_PERMISSIONS_DENIED = 'waitingRoom/SET_PERMISSIONS_DENIED'
export const SET_IS_REQUESTING_ROOM_INFO = 'waitingRoom/SET_IS_REQUESTING_ROOM_INFO'
export const SET_PROVIDER_INITIATING_VISIT = 'waitingRoom/SET_PROVIDER_INITIATING_VISIT'

export const orderData = [
  {
    name: 'Semaglutide',
    prescriptions: [
      {
        name: 'Compounded',
        description: '1 month',
        lowCost: 100,
        highCost: 600,
        cost: '',
        disallowedStates: [],
        doses: [
          {
            name: '0.625 mg',
            cost: 514,
            note: 'weekly x3 weeks',
            prescriptionName: 'Compounded',
            prescriptionDescription: '1 month',
          },
          {
            name: '1.025 mg',
            cost: 714,
            note: 'weekly x3 weeks',
            prescriptionName: 'Compounded',
            prescriptionDescription: '1 month',
          },
          {
            name: '1.25 mg',
            cost: 804,
            note: 'weekly x3 weeks',
            prescriptionName: 'Compounded',
            prescriptionDescription: '1 month',
          },
          {
            name: '1.5 mg',
            cost: 1214,
            note: 'weekly x3 weeks',
            prescriptionName: 'Compounded',
            prescriptionDescription: '1 month',
          },
        ],
      },
      {
        name: 'Compounded',
        description: '3 months',
        lowCost: 120,
        highCost: 800,
        disallowedStates: ['AL', 'FL', 'SC', 'MI', 'AK', 'IN'],
        doses: [
          {
            name: '0.625 mg',
            cost: 514,
            note: 'weekly x3 weeks',
            prescriptionName: 'Compounded',
            prescriptionDescription: '3 months',
          },
          {
            name: '1.025 mg',
            cost: 714,
            note: 'weekly x3 weeks',
            prescriptionName: 'Compounded',
            prescriptionDescription: '3 months',
          },
          {
            name: '1.25 mg',
            cost: 804,
            note: 'weekly x3 weeks',
            prescriptionName: 'Compounded',
            prescriptionDescription: '3 months',
          },
          {
            name: '1.5 mg',
            cost: 1214,
            note: 'weekly x3 weeks',
            prescriptionName: 'Compounded',
            prescriptionDescription: '3 months',
          },
        ],
      },
      {
        name: 'Branded (Ozempic)',
        description: '1 month',
        lowCost: 215,
        highCost: 900,
        disallowedStates: [],
        doses: [
          {
            name: '0.625 mg',
            cost: 514,
            note: 'weekly x3 weeks',
            prescriptionName: 'Branded (Ozempic)',
            prescriptionDescription: '1 month',
          },
          {
            name: '1.025 mg',
            cost: 714,
            note: 'weekly x3 weeks',
            prescriptionName: 'Branded (Ozempic)',
            prescriptionDescription: '1 month',
          },
          {
            name: '1.25 mg',
            cost: 804,
            note: 'weekly x3 weeks',
            prescriptionName: 'Branded (Ozempic)',
            prescriptionDescription: '1 month',
          },
          {
            name: '1.5 mg',
            cost: 1214,
            note: 'weekly x3 weeks',
            prescriptionName: 'Branded (Ozempic)',
            prescriptionDescription: '1 month',
          },
        ],
      },
      {
        name: 'Branded (Ozempic)',
        description: '3 months',
        lowCost: 400,
        highCost: 1100,
        disallowedStates: ['AL', 'FL', 'SC', 'MI', 'AK', 'IN'],
        doses: [
          {
            name: '0.625 mg',
            cost: 514,
            note: 'weekly x3 weeks',
            prescriptionName: 'Branded (Ozempic)',
            prescriptionDescription: '3 months',
          },
          {
            name: '1.025 mg',
            cost: 714,
            note: 'weekly x3 weeks',
            prescriptionName: 'Branded (Ozempic)',
            prescriptionDescription: '3 months',
          },
          {
            name: '1.25 mg',
            cost: 804,
            note: 'weekly x3 weeks',
            prescriptionName: 'Branded (Ozempic)',
            prescriptionDescription: '3 months',
          },
          {
            name: '1.5 mg',
            cost: 1214,
            note: 'weekly x3 weeks',
            prescriptionName: 'Branded (Ozempic)',
            prescriptionDescription: '3 months',
          },
        ],
      },
    ],
  },
  {
    name: 'Semaglutide - 2',
    prescriptions: [
      {
        name: 'Compounded',
        description: '1 month',
        lowCost: 100,
        highCost: 600,
        disallowedStates: [],
        doses: [
          {
            name: '0.625 mg',
            cost: 514,
            note: 'weekly x3 weeks',
            prescriptionName: 'Compounded',
            prescriptionDescription: '1 month',
          },
          {
            name: '1.025 mg',
            cost: 714,
            note: 'weekly x3 weeks',
            prescriptionName: 'Compounded',
            prescriptionDescription: '1 month',
          },
          {
            name: '1.25 mg',
            cost: 804,
            note: 'weekly x3 weeks',
            prescriptionName: 'Compounded',
            prescriptionDescription: '1 month',
          },
          {
            name: '1.5 mg',
            cost: 1214,
            note: 'weekly x3 weeks',
            prescriptionName: 'Compounded',
            prescriptionDescription: '1 month',
          },
        ],
      },
      {
        name: 'Compounded',
        description: '3 months',
        lowCost: 120,
        highCost: 800,
        disallowedStates: ['AL', 'FL', 'SC', 'MI', 'AK', 'IN'],
        doses: [
          {
            name: '0.625 mg',
            cost: 514,
            note: 'weekly x3 weeks',
          },
          {
            name: '1.025 mg',
            cost: 714,
            note: 'weekly x3 weeks',
          },
          {
            name: '1.25 mg',
            cost: 804,
            note: 'weekly x3 weeks',
          },
          {
            name: '1.5 mg',
            cost: 1214,
            note: 'weekly x3 weeks',
          },
        ],
      },
      {
        name: 'Branded (Ozempic)',
        description: '1 month',
        lowCost: 215,
        highCost: 900,
        disallowedStates: [],
        doses: [
          {
            name: '0.625 mg',
            cost: 514,
            note: 'weekly x3 weeks',
            prescriptionName: 'Branded (Ozempic)',
            prescriptionDescription: '1 month',
          },
          {
            name: '1.025 mg',
            cost: 714,
            note: 'weekly x3 weeks',
          },
          {
            name: '1.25 mg',
            cost: 804,
            note: 'weekly x3 weeks',
            prescriptionName: 'Branded (Ozempic)',
            prescriptionDescription: '1 month',
          },
          {
            name: '1.5 mg',
            cost: 1214,
            note: 'weekly x3 weeks',
            prescriptionName: 'Branded (Ozempic)',
            prescriptionDescription: '1 month',
          },
        ],
      },
      {
        name: 'Branded (Ozempic)',
        description: '3 months',
        lowCost: 400,
        highCost: 1100,
        disallowedStates: ['AL', 'FL', 'SC', 'MI', 'AK', 'IN'],
        doses: [
          {
            name: '0.625 mg',
            cost: 514,
            note: 'weekly x3 weeks',
            prescriptionName: 'Branded (Ozempic)',
            prescriptionDescription: '3 months',
          },
          {
            name: '1.025 mg',
            cost: 714,
            note: 'weekly x3 weeks',
            prescriptionName: 'Branded (Ozempic)',
            prescriptionDescription: '3 months',
          },
          {
            name: '1.25 mg',
            cost: 804,
            note: 'weekly x3 weeks',
            prescriptionName: 'Branded (Ozempic)',
            prescriptionDescription: '3 months',
          },
          {
            name: '1.5 mg',
            cost: 1214,
            note: 'weekly x3 weeks',
            prescriptionName: 'Branded (Ozempic)',
            prescriptionDescription: '3 months',
          },
        ],
      },
    ],
  },
  {
    name: 'Semaglutide - 3',
    prescriptions: [
      {
        name: 'Compounded',
        description: '1 month',
        lowCost: 100,
        highCost: 600,
        disallowedStates: [],
        doses: [
          {
            name: '0.625 mg',
            cost: 514,
            note: 'weekly x3 weeks',
            prescriptionName: 'Compounded',
            prescriptionDescription: '1 month',
          },
          {
            name: '1.025 mg',
            cost: 714,
            note: 'weekly x3 weeks',
            prescriptionName: 'Compounded',
            prescriptionDescription: '1 month',
          },
          {
            name: '1.25 mg',
            cost: 804,
            note: 'weekly x3 weeks',
            prescriptionName: 'Compounded',
            prescriptionDescription: '1 month',
          },
          {
            name: '1.5 mg',
            cost: 1214,
            note: 'weekly x3 weeks',
            prescriptionName: 'Compounded',
            prescriptionDescription: '1 month',
          },
        ],
      },
      {
        name: 'Compounded',
        description: '3 months',
        lowCost: 120,
        highCost: 800,
        disallowedStates: ['AL', 'FL', 'SC', 'MI', 'AK', 'IN'],
        doses: [
          {
            name: '0.625 mg',
            cost: 514,
            note: 'weekly x3 weeks',
            prescriptionName: 'Compounded',
            prescriptionDescription: '3 months',
          },
          {
            name: '1.025 mg',
            cost: 714,
            note: 'weekly x3 weeks',
            prescriptionName: 'Compounded',
            prescriptionDescription: '3 months',
          },
          {
            name: '1.25 mg',
            cost: 804,
            note: 'weekly x3 weeks',
            prescriptionName: 'Compounded',
            prescriptionDescription: '3 months',
          },
          {
            name: '1.5 mg',
            cost: 1214,
            note: 'weekly x3 weeks',
            prescriptionName: 'Compounded',
            prescriptionDescription: '3 months',
          },
        ],
      },
      {
        name: 'Branded (Ozempic)',
        description: '1 month',
        lowCost: 215,
        highCost: 900,
        disallowedStates: [],
        doses: [
          {
            name: '0.625 mg',
            cost: 514,
            note: 'weekly x3 weeks',
            prescriptionName: 'Branded (Ozempic)',
            prescriptionDescription: '1 month',
          },
          {
            name: '1.025 mg',
            cost: 714,
            note: 'weekly x3 weeks',
            prescriptionName: 'Branded (Ozempic)',
            prescriptionDescription: '1 month',
          },
          {
            name: '1.25 mg',
            cost: 804,
            note: 'weekly x3 weeks',
            prescriptionName: 'Branded (Ozempic)',
            prescriptionDescription: '1 month',
          },
          {
            name: '1.5 mg',
            cost: 1214,
            note: 'weekly x3 weeks',
            prescriptionName: 'Branded (Ozempic)',
            prescriptionDescription: '1 month',
          },
        ],
      },
      {
        name: 'Branded (Ozempic)',
        description: '3 months',
        lowCost: 400,
        highCost: 1100,
        disallowedStates: ['AL', 'FL', 'SC', 'MI', 'AK', 'IN'],
        doses: [
          {
            name: '0.625 mg',
            cost: 514,
            note: 'weekly x3 weeks',
            prescriptionName: 'Branded (Ozempic)',
            prescriptionDescription: '3 months',
          },
          {
            name: '1.025 mg',
            cost: 714,
            note: 'weekly x3 weeks',
            prescriptionName: 'Branded (Ozempic)',
            prescriptionDescription: '3 months',
          },
          {
            name: '1.25 mg',
            cost: 804,
            note: 'weekly x3 weeks',
            prescriptionName: 'Branded (Ozempic)',
            prescriptionDescription: '3 months',
          },
          {
            name: '1.5 mg',
            cost: 1214,
            note: 'weekly x3 weeks',
            prescriptionName: 'Branded (Ozempic)',
            prescriptionDescription: '3 months',
          },
        ],
      },
    ],
  },
]
